<template>
  <div class="recruitment-dashboard" :class="showAdd ? 'page-hide' : ''">
    <!-- 頂部標題欄 -->
    <div class="page-title u-flex">
      <div>
        <div class="page-title-main">發票管理</div>
        <div class="page-title-sub">大學問總管理中心</div>
      </div>
    </div>

    <div class="era-content-grid">
      <!-- 左侧排行榜 -->
      <section class="era-ranking-section">
        <div class="era-section-header">
          <div class="era-section-title u-flex page-filter-top align-start">
            <div class="u-flex page-filter flex-wrap gap-10">
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.merchantTradeNo"
                type="text"
                placeholder="搜尋统一业务订单号"
              >
              </el-input>
              <el-select
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.invoiceType"
                type="select"
                placeholder="搜尋發票類型"
              >
                <el-option label="B2C" value="B2C" />
                <el-option label="B2B" value="B2B" />
              </el-select>
              <el-select
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.status"
                type="select"
                placeholder="搜尋發票處理狀態"
              >
                <el-option label="待處理" value="PENDING" />
                <el-option label="處理中" value="PROCESSING" />
                <el-option label="處理成功" value="SUCCEEDED" />
                <el-option label="處理失敗" value="FAILED" />
              </el-select>
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.email"
                type="text"
                placeholder="搜尋發票收件Email"
              >
              </el-input>
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.customerIdentifier"
                type="text"
                placeholder="搜尋統一企業編號"
              >
              </el-input>
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.customerName"
                type="text"
                placeholder="搜尋企業名稱"
              >
              </el-input>
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.invoiceNo"
                type="text"
                placeholder="搜尋發票號碼"
              >
              </el-input>
              <el-date-picker
                v-model="search.beginInvoiceDate"
                type="date"
                placeholder="选择發票日期起"
                class="input-date"
                @change="initData"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-date-picker
                v-model="search.beginCreateTime"
                type="date"
                placeholder="选择發票日期止"
                class="input-date"
                @change="initData"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-date-picker
                v-model="search.beginCreateTime"
                type="date"
                placeholder="选择發票創建日期起"
                class="input-date"
                @change="initData"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-date-picker
                v-model="search.endCreateTime"
                type="date"
                placeholder="选择發票創建日期止"
                class="input-date"
                @change="initData"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
        </div>

        <div class="era-table-container">
          <div class="ranking-table" style="margin-top: 0; min-width: 8rem">
            <div class="table-header">
              <span>商戶訂單號</span>
              <span>收件Email</span>
              <span>開票狀態</span>
              <span>統一編號</span>
              <span>企業名稱</span>
              <span>載具號碼</span>
              <span>金額</span>
              <span>發票類型</span>
              <span>發票日期</span>
              <span>發票號碼</span>
              <span>發票隨機碼</span>
              <span>失敗原因</span>
              <span>操作</span>
            </div>
            <div
              class="table-row"
              v-for="(item, index) in dataList"
              :key="item.id"
            >
              <span style="font-size: 12px">{{ item.orderId }}</span>
              <span>{{ item.email }}</span>
              <span>{{ item.status }}</span>
              <span>{{ item.merchantTradeNo }}</span>
              <span>{{ item.customerName || "--" }}</span>
              <span>{{ item.carrierNum || "--" }}</span>
              <span>{{ item.amount || "--" }}</span>
              <span>{{ item.invoiceType }}</span>
              <span
                >{{ item.invoiceDate?.split(" ")[0] }}<br />{{
                  item.invoiceDate?.split(" ")[1]
                }}</span
              >
              <span>{{ item.invoiceNo || "--" }}</span>
              <span>{{ item.randomNumber || "--" }}</span>
              <span>{{ item.errorMessage || "--" }}</span>
              <span class="item-btn">
                <div class="btn btn-edit" @click="toSee(item)">查看</div>
                <div
                  class="btn btn-edit"
                  @click="retry(item)"
                  v-if="item.status === 'FAILED'"
                >
                  重試
                </div>
              </span>
            </div>
          </div>
        </div>
        <div
          class="era-search u-flex"
          style="justify-content: center; margin-top: 0.2rem"
        >
          <el-pagination
            @current-change="currentChange"
            background
            layout="prev, pager, next"
            :total="dataTotal"
          >
          </el-pagination>
        </div>
      </section>

      <!-- 新增/编辑學生信息 -->
      <div class="dialog-fixed-right" :class="showAdd ? 'show' : ''">
        <div class="dialog-fixed-modal" v-if="showAdd"></div>
        <div class="dialog-fixed-content">
          <div class="title" style="margin-top: 0.1rem">
            發票詳情
            <span @click="showAdd = false">
              <i class="el-icon-close" style="font-size: 0.3rem"></i>
            </span>
          </div>
          <div>
            <div class="title">發票信息</div>
            <div class="date-container">
              <div class="date-input-group">
                <label class="date-label"> 发票 ID</label>
                <el-input
                  class="input-date"
                  v-model="post.id"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label"> 支付訂單 ID</label>
                <el-input
                  class="input-date"
                  v-model="post.orderId"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">統一業務訂單號</label>
                <el-input
                  class="input-date"
                  v-model="post.merchantTradeNo"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票類型</label>
                <el-input
                  class="input-date"
                  v-model="post.invoiceType"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票收件Email</label>
                <el-input
                  class="input-date"
                  v-model="post.email"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">企業統一編號</label>
                <el-input
                  class="input-date"
                  v-model="post.customerIdentifier"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">企業名稱</label>
                <el-input
                  class="input-date"
                  v-model="post.customerName"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">企業地址</label>
                <el-input
                  class="input-date"
                  v-model="post.customerAddr"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">載具類型</label>
                <el-input
                  class="input-date"
                  v-model="post.carrierType"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">載具號碼</label>
                <el-input
                  class="input-date"
                  v-model="post.carrierNum"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">開票金額</label>
                <el-input
                  class="input-date"
                  v-model="post.amount"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">品項名稱</label>
                <el-input
                  class="input-date"
                  v-model="post.itemName"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">開票狀態</label>
                <el-input
                  class="input-date"
                  v-model="post.status"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票號</label>
                <el-input
                  class="input-date"
                  v-model="post.invoiceNo"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票隨機號</label>
                <el-input
                  class="input-date"
                  v-model="post.randomNumber"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">最近一次開票失敗原因</label>
                <el-input
                  class="input-date"
                  v-model="post.errorMessage"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票日期</label>
                <el-input
                  class="input-date"
                  v-model="post.invoiceDate"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">重試次數</label>
                <el-input
                  class="input-date"
                  v-model="post.retryCount"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">下一次重試時間</label>
                <el-input
                  class="input-date"
                  v-model="post.nextRetryTime"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">發票通知時間</label>
                <el-input
                  class="input-date"
                  v-model="post.notifiedTime"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">創建時間</label>
                <el-input
                  class="input-date"
                  v-model="post.createTime"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">更新時間</label>
                <el-input
                  class="input-date"
                  v-model="post.updateTime"
                  type="text"
                  readonly
                >
                </el-input>
              </div>
            </div>
          </div>
          <div class="dialog-footer" style="margin-top: 0.2rem">
            <el-button size="" type="primary" @click="showAdd = false">
              確定
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiBaseUrl } from "../../api/config";
export default {
  components: {},
  data() {
    return {
      baseUrl: apiBaseUrl,
      page: 1,
      dataList: [],
      dataTotal: 0,
      search: {
        merchantTradeNo: "",
        invoiceType: "",
        status: "",
        email: "",
        customerIdentifier: "",
        customerName: "",
        invoiceNo: "",
        beginInvoiceDate: "",
        endInvoiceDate: "",
        beginCreateTime: "",
        endCreateTime: "",
        pageSize: 10,
      },
      showAdd: false,
      post: {
        id: "",
        orderId: "",
        merchantTradeNo: "",
        invoiceType: "",
        email: "",
        customerIdentifier: "",
        customerName: "",
        customerAddr: "",
        carrierType: "",
        carrierNum: "",
        amount: "",
        itemName: "",
        status: "",
        invoiceNo: "",
        randomNumber: "",
        errorMessage: "",
        invoiceDate: "",
        retryCount: "",
        nextRetryTime: "",
        notifiedTime: "",
        createTime: "",
        updateTime: "",
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    toSee(item) {
      const that = this;

      that.$axios
        .post("rest-api/pay/app/invoice/detail", {
          id: item.id,
        })
        .then((res) => {
          that.post = {
            ...that.post,
            ...res.data,
          };
          that.showAdd = true;
        })
        .catch((err) => {});
    },
    retry(item) {
      const that = this;
      that.$axios
        .post("rest-api/pay/app/invoice/retry", {
          id: item.id,
        })
        .then((res) => {
          that.$message({
            message: "重試成功",
            type: "success",
          });
          that.getList();
        })
        .catch((err) => {});
    },
    currentChange(e) {
      this.page = e;
      this.getList();
    },
    initData() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const that = this;
      that.$axios
        .post("rest-api/pay/app/invoice/page", {
          pageNum: that.page,
          ...that.search,
        })
        .then((res) => {
          that.dataList = res.data.list;
          that.dataTotal = res.data.total;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.recruitment-dashboard {
  min-height: 100vh;
  background: #eef3f6;
  padding: 0.2rem;
}

/* 頂部標題欄 */
.dashboard-header {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
}

.help-btn {
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.08rem 0.2rem;
  border-radius: 0.06rem;
  font-size: 0.2rem;
  cursor: pointer;
}

/* 日期選擇區域 */
.date-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
}

.date-container {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.date-input-group {
  width: 32%;
  min-width: 32%;
  margin-right: 1.2%;
  margin-bottom: 0.2rem;
}

.date-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.08rem;
  color: #222;
  font-size: 0.18rem;
}

.date-input {
  background: #91a2a41a;
  border: 0.01rem solid #91a2a480;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  padding: 0.12rem 0.1rem;
  color: #999;
}

/* 核心數據指標 */
.kpi-section {
  flex: 1;
  margin-right: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.section-title {
  font-weight: bold;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #2d3748;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
  gap: 0.2rem;
}

.kpi-card {
  background: white;
  position: relative;
  border-radius: 0.12rem;
  padding: 0.25rem;
  box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

  .ic-block {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  }
}

.kpi-header {
  margin-bottom: 00.17rem;
}

.kpi-name {
  font-size: 0.18rem;
  color: #777;
}

.kpi-value {
  font-size: 0.32rem;
  color: #000;
  margin-bottom: 0.4rem;
}

.kpi-comparison {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-size: 0.12rem;
}

.kpi-comparison.positive {
  color: #21c93a;
}

.trend-icon {
  font-weight: bold;
}

/* 主要內容區域 */
.main-content {
  flex: 1;
  margin-left: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
}

/* 排行榜樣式 */
.ranking-section {
  flex: 1;
  margin-left: 0.1rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}

.ranking-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

.ranking-table {
  border: 0.01rem solid #27545726;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  overflow: hidden;
}

.ranking-date {
  color: #718096;
  font-size: 0.2rem;
}

.ranking-subtitle {
  color: #718096;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
}

.table-header {
  display: flex;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e2e8f0;
  background: #0ba29b0f;
  color: #4a5568;
  font-size: 0.18rem;
}

.table-header span {
  flex: 1;
  text-align: center;
}

.table-row span {
  flex: 1;
  word-break: break-all;
  text-align: center;
}

.table-row {
  display: flex;
  padding: 0.12rem 0;
  font-size: 0.18rem;
  border-bottom: 0.01rem solid #e2e8f0;
}

.rank {
  color: #4a5568;
}

.department {
  color: #2d3748;
}

.area,
.rate {
  text-align: right;
  color: #4a5568;
}

/* 篩選區域樣式 */
.filter-section {
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.2rem;
}

.filter-btn {
  flex: 1;
  padding: 0.1rem;
  border: 0.01rem solid #e2e8f0;
  background: #f7fafc;
  border-radius: 0.08rem;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.primary-btn {
  width: 100%;
  padding: 0.12rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  cursor: pointer;
  margin-bottom: 0.2rem;
}

.dropdown {
  width: 100%;
  padding: 0.12rem;
  border: 0.01rem solid #e2e8f0;
  border-radius: 0.08rem;
  background: white;
  margin-bottom: 0.2rem;
}

.stats-info {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.stat-item {
  padding: 0.1rem;
  background: #f7fafc;
  border-radius: 0.06rem;
  text-align: center;
  color: #718096;
  font-size: 0.2rem;
}

/* 響應式設計 */
@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
}

@media (max-width: 768px) {
  .recruitment-dashboard {
    padding: 0.1rem;
  }

  .header-content {
    flex-direction: column;
    gap: 00.17rem;
    align-items: flex-start;
  }

  .date-container {
    flex-direction: column;
    gap: 00.17rem;
  }

  .kpi-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
    gap: 0.1rem;
    font-size: 0.2rem;
  }

  .filter-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .kpi-value {
    font-size: 0.24rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
    gap: 0.08rem;
  }

  .ranking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
  }
}

.search-title {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 0.28rem;
}

.modle-block2 {
  display: flex;
}

@media (max-width: 1024px) {
  .modle-block2 {
    display: block;
  }

  .kpi-section {
    margin-right: 0;
  }

  .ranking-section {
    margin-left: 0;
  }
}

/* 页面标题 */
.era-header {
  margin-bottom: 0.3rem;
}

.era-main-title {
  font-size: 0.28rem;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
}

/* 内容网格布局 */
.era-content-grid {
  display: grid;
  // grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
  margin: 0 auto;
}

/* 排行榜区域 */
.era-ranking-section {
}

.era-section-header {
  margin: 0 0 0.2rem;
}

.era-section-title {
  font-weight: bold;
  color: #2d3748;
  justify-content: space-between;

  .title-btn {
    background: #0ba29b;
    padding: 0.12rem;
    border-radius: 0.06rem;
    color: #fff;
    cursor: pointer;
    font-size: 0.2rem;
  }

  .tips {
    font-weight: normal;
    font-size: 0.12rem;
    color: #ed6d00;
    margin-left: 0.3rem;
  }

  img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.06rem;
  }
}

.era-section-title-sub {
  font-size: 00.17rem;
  font-weight: bold;
  color: #0ba29b;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
}

/* 表格样式 */
.era-table-container {
  overflow-x: auto;
}

.era-ranking-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.2rem;
}

.era-ranking-table th {
  background: #f8fafc;
  padding: 0.12rem 0.08rem;
  text-align: left;
  font-weight: bold;
  color: #4a5568;
  border-bottom: 0.02rem solid #e2e8f0;
}

.era-ranking-table td {
  padding: 0.12rem 0.08rem;
  border-bottom: 0.01rem solid #e2e8f0;
  color: #4a5568;
}

.era-ranking-table .era-highlight-row {
  background: #fffaf0;
}

.era-ranking-table .era-highlight-row td {
  font-weight: 500;
}

.era-rank-col {
  width: 0.6rem;
}

.era-name-col {
  min-width: 2rem;
}

.era-private-col {
  width: 1.2rem;
}

.era-growth-col {
  width: 1rem;
}

.era-school-col {
  width: 1.4rem;
}

.era-rank-cell {
  text-align: center;
}

.era-rank-number {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  line-height: 0.28rem;
  text-align: center;
  background: #667eea;
  color: white;
  border-radius: 50%;
  font-size: 0.12rem;
  font-weight: bold;
}

.era-ranking-table .era-highlight-row .era-rank-number {
  background: #ed8936;
}

.era-name-cell {
  color: #2d3748;
  font-weight: 500;
}

.era-growth-cell {
  text-align: center;
}

.era-growth-rate.era-positive {
  color: #48bb78;
  font-weight: bold;
}

.era-school-cell {
  text-align: right;
}

/* 右侧数据面板 */
.era-stats-panel {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.4rem;
}

.era-chart-section,
.era-quality-section {
  background: #eef6f685;
  border-radius: 00.17rem;
  padding: 0 00.17rem 00.17rem;
}

.era-chart-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

/* 管道列表 */
.era-channel-list {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-channel-item {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.08rem 0;
}

.era-channel-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
}

.era-channel-dot.era-organic {
  background: #48bb78;
}

.era-channel-dot.era-referral {
  background: #ed8936;
}

.era-channel-dot.era-social {
  background: #9f7aea;
}

.era-channel-dot.era-paid {
  background: #4299e1;
}

.era-channel-dot.era-direct {
  background: #f56565;
}

.era-channel-name {
  color: #4a5568;
  font-size: 0.2rem;
}

/* 品质评比表格 */
.era-quality-table {
  display: flex;
  flex-direction: column;
  gap: 00.17rem;
}

.era-table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  padding-bottom: 0.1rem;
  border-bottom: 0.02rem solid #e2e8f0;
  font-weight: bold;
  color: #4a5568;
  font-size: 0.12rem;
}

.era-table-body {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  align-items: center;
}

.era-channel-cell {
  font-size: 0.12rem;
  color: #4a5568;
  font-weight: 500;
}

.era-progress-cell {
  position: relative;
}

.era-progress-bar {
  position: relative;
  height: 0.24rem;
  background: #f7fafc;
  border-radius: 0.12rem;
  overflow: hidden;
}

.era-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 0.12rem;
  transition: width 0.3s ease;
}

.era-progress-fill.era-depth-fill {
  background: linear-gradient(90deg, #48bb78, #38a169);
}

.era-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.11rem;
  font-weight: bold;
  color: #2d3748;
  z-index: 1;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .era-content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }

  .era-stats-panel {
    flex-direction: row;
  }

  .era-stats-panel {
    padding-top: 0;
  }

  .era-chart-section,
  .era-quality-section {
    flex: 1;
  }

  .page-title {
    display: block;

    .page-title-btn {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }
}

@media (max-width: 768px) {
  .date-input-group {
    width: 100%;
    min-width: 100%;
    margin: 0;
  }

  .dialog-account {
    width: 90% !important;
  }

  .era-container {
    padding: 00.17rem;
  }

  .era-section-title {
    .tips {
      margin-left: 0;
      margin-top: 00.17rem;
    }
  }

  .era-main-title {
    font-size: 0.22rem;
  }

  .era-content-grid {
    gap: 00.17rem;
  }

  .era-stats-panel {
    flex-direction: column;
  }

  .era-ranking-table {
    font-size: 0.12rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.08rem 0.06rem;
  }

  .era-name-col {
    min-width: 1.5rem;
  }

  .era-private-col {
    width: 1rem;
  }

  .era-growth-col {
    width: 0.8rem;
  }

  .era-school-col {
    width: 1.2rem;
  }
}

@media (max-width: 480px) {
  .era-container {
    padding: 0.1rem;
  }

  .era-main-title {
    font-size: 0.2rem;
  }

  .era-ranking-table {
    font-size: 0.11rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.06rem 0.04rem;
  }

  .era-table-header,
  .era-table-row {
    grid-template-columns: 1fr 1fr;
    gap: 0.1rem;
  }

  .era-table-header .era-depth-header,
  .era-table-row .era-progress-cell:last-child {
    display: none;
  }

  .era-rank-number {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    font-size: 0.11rem;
  }
}

.era-content-grid {
  margin-top: 0.2rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
}

.page-title {
  justify-content: space-between;
  margin: 0 0 0.3rem;

  .page-title-main {
    font-size: 0.26rem;
    font-weight: bold;
  }

  .page-title-sub {
    color: #0ba29b;
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.12rem;
  }
}

.module-show {
  background: #ed6d001a;
  color: #ed6d00;
  font: size 0.2rem;
  padding: 0.2rem;
  margin-top: 0.3rem;
}

.tips1 {
  background: #ed6d001a;
  border-radius: 16px;
  font-size: 0.12rem;
  color: #ed6d00;
  padding: 0.08rem 0.2rem;
}

.item-btn {
  display: flex;
  justify-content: center;

  .btn {
    cursor: pointer;
    padding: 0 0.05rem;
  }

  .btn-edit {
    color: #0ba29b;
  }

  .btn-del {
    color: #ff383c;
  }
}

.module-count {
  background: #f3f3f3;
  border: 1px dashed #275457;
  border-radius: 10px;
  padding: 0.3rem 0.24rem;

  .module-header {
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
}

.btn-add {
  background: #0ba29b;
  padding: 0.12rem;
  border-radius: 0.06rem;
  color: #fff;
  font-size: 0.2rem;
  margin-top: 0.2rem;
}

.input-tips {
  font-size: 0.12rem;
  color: #999;
}

.title {
  font-size: 0.2rem;
  color: #222;
  margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.dialog-account {
  width: 8rem;
  margin: 0 auto;

  ::v-deep .el-dialog {
    width: 100% !important;
    overflow: auto;
  }
}

.module-role {
  border-top: 1px dashed #e1e1e1;
  padding-top: 0.3rem;
  margin-top: 0.3rem;
}

.module-contract-add {
  position: fixed;
  top: 0;
  right: -100%;
  opacity: 0;
  transition: 0.5s ease-in-out;
  width: 30%;
  z-index: 100;
  bottom: 0;
  display: block;
  background-color: #f7f8fc;
  padding: 0.2rem;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
}

.module-contract-add .date-input-group {
  width: 100%;
  min-width: 100%;
  margin: 0 0 0.2rem;
}

.module-contract-add.show {
  opacity: 1;
  right: 0;
}

.contract-list {
  .item {
    margin-bottom: 0.24rem;
  }

  .item-date {
    font-size: 0.14rem;
    font-weight: bold;
  }

  .item-content {
    border: 1px solid #949baa4d;
    border-radius: 5px;
    padding: 0.06rem 0.12rem;
    margin-top: 0.1rem;
  }

  .item-show {
    font-size: 0.14rem;
    display: flex;
    justify-content: space-between;
    padding: 0.06rem;
  }
}

@media (max-width: 1024px) {
  .module-contract-add {
    width: 90%;
  }

  .module-contract-add .date-input-group {
    margin: 0;
  }
}
.page-filter .input-date {
  width: 1.3rem !important;
}
.avatar-uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  height: 0.4rem;
  width: 0.4rem;
}
</style>
